var _rect, _path, _g, _path2, _path3, _circle, _circle2, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 225,
    viewBox: "0 0 221 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 114.018,
    width: 192,
    height: 110,
    fill: "url(#paint0_linear_1508_31073)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.166 83.3227C105.039 81.8193 110.247 81.7821 115.14 83.2157L201.676 108.565C207.399 110.241 207.437 118.335 201.729 120.065L115.378 146.232C110.337 147.759 104.95 147.72 99.9323 146.118L18.214 120.038C12.618 118.252 12.6564 110.32 18.2695 108.589L100.166 83.3227Z",
    fill: "#3D3D3D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1508_31073)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.5,
    cy: 112.018,
    rx: 26.5,
    ry: 2,
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7679 108.64L92.7837 114.274L142 21.9687L128.452 17.0422C126.53 16.3433 124.44 16.2505 122.464 16.776L82.9578 27.283C80.3294 27.9821 78.4999 30.3617 78.4999 33.0815L78.4999 103.298C78.4999 105.551 79.762 107.614 81.7679 108.64Z",
    fill: "url(#paint1_linear_1508_31073)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4571 38.6559C90.4571 35.9015 92.3325 33.5009 95.005 32.8343L139.133 21.8275C142.919 20.8831 146.585 23.747 146.585 27.6491L146.585 96.0241C146.585 98.6644 144.859 100.994 142.333 101.764L98.2054 115.205C94.3505 116.379 90.4571 113.495 90.4571 109.466L90.4571 38.6559Z",
    fill: "#4671F6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 60.468,
    r: 20,
    fill: "url(#paint2_linear_1508_31073)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 60.468,
    r: 4,
    fill: "#4671F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98 82.3383C98 79.9249 99.2209 77.6752 101.244 76.3599L113.204 68.5864C114.791 67.5549 116.79 69.1002 116.191 70.8957L111.589 84.7003C110.64 87.548 107.975 89.4688 104.974 89.4688C101.122 89.4688 98 86.3465 98 82.4951L98 82.3383Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1508_31073",
    x: 69,
    y: 96.0178,
    width: 81,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1508_31073"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1508_31073",
    x1: 206,
    y1: 169.018,
    x2: 14,
    y2: 169.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1508_31073",
    x1: 117,
    y1: 2.46863,
    x2: 70,
    y2: 61.9687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5780FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#698EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635417,
    stopColor: "#A4BCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1508_31073",
    x1: 81.5002,
    y1: 94.4686,
    x2: 138,
    y2: 49.4686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationDark);
export default __webpack_public_path__ + "static/media/illustration-dark.ae984be915a06d6be59f42d86fcee621.svg";
export { ForwardRef as ReactComponent };